<template>
  <transition name="fade">
      <!-- El popup será visible solo cuando visible sea true -->
      <div
        v-if="visible"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      >
      <img src="@/assets/images/loading.gif" alt="Cargando..." style="width: 100px; height: 100px;" />
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';

  // Define las props del componente para recibir el mensaje de error
const props = defineProps({
  isLoading: Boolean,
});

const visible = ref(false);

  // Hacer visible el popup cuando haya un mensaje de error
watch(() => props.isLoading, (newVal) => {
  visible.value = newVal;
});
  
</script>

<style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}
  .fade-enter, .fade-leave-to {
  opacity: 0;
}

  /* Fondo translúcido detrás del popup */
  .fixed {
  position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}
</style>
  